import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('nile-rte-divider')
export class NileRteDivider extends LitElement {
  protected createRenderRoot() { return this; }
  protected shouldUpdate() { return false; }
}
declare global { interface HTMLElementTagNameMap { 'nile-rte-divider': NileRteDivider; } }
